import { Button, DataHeader, DataSource, Label, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomFuelSurchargeTableMaster extends Layout {
    buttonBuildTable: Button;
    dataheaderCustomFscTable: DataHeader;
    labelC: Label;
    sourceCustomFscDtl: DataSource;
    sourceCustomFscHdr: DataSource;
    tableCustomFscDetails: Table;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
